import React from "react";
import { Input } from "../../../../shared/ui/controls/Input/Input";
import { FieldWrapper } from "../../../../shared/ui";
import { FilterBar } from "../../../../shared/ui/layouts/FilterBar";
import { WorkOrderStatusSelect } from "src/entities/work-order";
import { GewerkSearchSelect } from "src/entities/gewerk";
import { workOrderColumns } from "../model/constants";
import {
  WORK_ORDER_FILTER_FIELDS_AFTER_GEWERK,
  WORK_ORDER_FILTER_FIELDS_BEFORE_GEWERK,
  type WorkOrderFilterField,
} from "../model/filterFields";
import type { WorkOrderFilterLayoutProps } from "../model/filterLayout.types";

/** Column-aligned filter row that sits on top of the list — one input per list column. */
export const WorkOrderFilterBarDesktop: React.FC<WorkOrderFilterLayoutProps> = ({
  filters,
  onFieldChange,
  onSortChange,
  onGewerkChange,
  onStatusChange,
}) => {
  const renderField = (field: WorkOrderFilterField) => (
    <FieldWrapper
      label={field.label}
      key={field.key}
      sortKey={field.sortKey}
      activeSortField={filters.sortField}
      sortOrder={filters.sortDirection}
      onSortChange={(sortKey, direction) =>
        onSortChange(
          sortKey as typeof filters.sortField,
          direction as typeof filters.sortDirection,
        )
      }
    >
      <Input
        as="input"
        value={filters[field.key]}
        onChange={(value) => onFieldChange(field.key, value)}
        placeholder=""
        type={field.type ?? "text"}
        inputMode={field.inputMode}
      />
    </FieldWrapper>
  );

  return (
    <FilterBar actionsButtons columns={workOrderColumns} gap={12} rowGap={8}>
      {WORK_ORDER_FILTER_FIELDS_BEFORE_GEWERK.map(renderField)}

      <FieldWrapper label="Gewerk">
        <GewerkSearchSelect value={filters.gewerkId} onChange={onGewerkChange} />
      </FieldWrapper>

      {WORK_ORDER_FILTER_FIELDS_AFTER_GEWERK.map(renderField)}

      <FieldWrapper label="Status">
        <WorkOrderStatusSelect value={filters.status} onChange={onStatusChange} withAllOption />
      </FieldWrapper>
    </FilterBar>
  );
};
